import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgSelectArrow = function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9268 6.57345C11.8292 6.47584 11.6708 6.47584 11.5732 6.57345L11.5732 6.57347L8.28033 9.86635C7.98744 10.1592 7.51256 10.1592 7.21967 9.86635C6.92678 9.57346 6.92678 9.09859 7.21967 8.80569L10.5126 5.51282C10.5126 5.51281 10.5126 5.51281 10.5126 5.5128C11.196 4.82939 12.304 4.82939 12.9874 5.5128C12.9874 5.51281 12.9874 5.51281 12.9874 5.51282L16.2803 8.80569C16.5732 9.09859 16.5732 9.57346 16.2803 9.86635C15.9874 10.1592 15.5126 10.1592 15.2197 9.86635L11.9268 6.57347L11.9268 6.57345ZM7.21967 14.8057C7.51256 14.5128 7.98744 14.5128 8.28033 14.8057L11.5732 18.0986C11.6708 18.1962 11.8292 18.1962 11.9268 18.0986L15.2197 14.8057C15.5126 14.5128 15.9874 14.5128 16.2803 14.8057C16.5732 15.0986 16.5732 15.5735 16.2803 15.8664L12.9874 19.1593C12.304 19.8427 11.196 19.8427 10.5126 19.1593L7.21967 15.8664C6.92678 15.5735 6.92678 15.0986 7.21967 14.8057Z"
  })));
};

export { SvgSelectArrow as ReactComponent };
//# sourceMappingURL=select-arrow.svg.js.map
